"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTimeslotEndDate = exports.setTimeslotStartDate = exports.compare = exports.TimeslotPostInterface = exports.TimeslotGetInterface = exports.TimeslotData = void 0;
const t = __importStar(require("io-ts"));
const Hours_1 = require("../Hours");
const Minutes_1 = require("../Minutes");
exports.TimeslotData = t.type({
    startHours: Hours_1.Hours,
    startMinutes: Minutes_1.Minutes,
    endHours: Hours_1.Hours,
    endMinutes: Minutes_1.Minutes,
    capacity: t.number,
});
exports.TimeslotGetInterface = t.type(Object.assign(Object.assign({}, exports.TimeslotData.props), { id: t.number, weekdayId: t.number }));
exports.TimeslotPostInterface = exports.TimeslotData;
function compare(left, right) {
    if (left.startHours < right.startHours) {
        return -1;
    }
    else if (left.startHours > right.startHours) {
        return 1;
    }
    else {
        return left.startMinutes - right.startMinutes;
    }
}
exports.compare = compare;
function setTimeslotStartDate(baseDate, timeslot) {
    return baseDate.set({
        hour: timeslot.startHours,
        minute: timeslot.startMinutes,
    });
}
exports.setTimeslotStartDate = setTimeslotStartDate;
function setTimeslotEndDate(baseDate, timeslot) {
    return baseDate.set({
        hour: timeslot.endHours,
        minute: timeslot.endMinutes,
    });
}
exports.setTimeslotEndDate = setTimeslotEndDate;
//# sourceMappingURL=Timeslot.js.map